import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Thumbnailable, ThumbNailBaseComponent } from '@app/shared/components/file-upload/thumb-nail-base.component';
import { TranslateService } from '@ngx-translate/core';
import { FileUploadStatus } from '@app/shared/models/dr-file';
import { FileUtilityService } from '@app/core/services/file-utility.service';
import { BaseModel } from '@app/shared/models/base';

@Component({
  selector: 'select-thumb-nail',
  templateUrl: './select-thumb-nail.component.html',
  styleUrls: ['./select-thumb-nail.component.scss']
})
export class SelectThumbNailComponent<T extends BaseModel & Thumbnailable> extends ThumbNailBaseComponent<T> {

  @Input()
  public selected?: boolean;

  @Input()
  public forList?: boolean;

  @Output()
  public select = new EventEmitter<Thumbnailable>();

  constructor(protected fileUtilityService: FileUtilityService,
              protected translateService: TranslateService) {
    super(fileUtilityService, translateService);
  }

  public selectFile(): void {
    if (!this.disabled && this.file.thumbnailStatus === FileUploadStatus.READY) {
      this.select.emit(this.file);
    }
  }
}
